import React, { useState, useCallback } from 'react';
import { Col, Select } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrTextInput from '../../../common/inputs/OnTraccrTextInput';
import SimpleFormModal from '../../../common/modals/SimpleFormModal';
import DisplayText from '../../../common/text/DisplayText';

import { CUSTOM_COLUMN_DATA_TYPES, CUSTOM_COLUMN_DATA_TYPE_OPTIONS } from './tableColumnHelpers';

const labelStyle = {
  textAlign: 'left',
  marginBottom: 4,
  height: 'auto',
};

function CustomColumnModal({
  title,
  visible,
  validator,
  placeholder,
  onClose,
  onSave,
}) {
  const [prevVisible, setPrevVisible] = useState(visible);
  const [errorText, setErrorText] = useState();
  const [value, setValue] = useState();
  const [customDataType, setCustomDataType] = useState(CUSTOM_COLUMN_DATA_TYPES.TEXT);

  const onTextChange = useCallback((e) => {
    const {
      target: {
        value: newValue,
      } = {},
    } = e;
    if (validator) setErrorText(validator(newValue));
    setValue(newValue);
  }, [validator]);

  const onSaveClicked = useCallback(() => (
    onSave(value, customDataType)
  ), [onSave, value, customDataType]);

  if (visible !== prevVisible) {
    setPrevVisible(visible);
    if (!visible) {
      setErrorText();
      setValue();
      setCustomDataType(CUSTOM_COLUMN_DATA_TYPES.TEXT);
    }
  }

  return (
    <SimpleFormModal
      title={title}
      visible={visible}
      errorText={errorText}
      disabled={errorText || !value}
      onClose={onClose}
      onSave={onSaveClicked}
    >
      <Col span={24}>
        <DisplayText title="Data type" style={labelStyle} />
        <Select
          style={{ width: '100%' }}
          value={customDataType}
          options={CUSTOM_COLUMN_DATA_TYPE_OPTIONS}
          onChange={setCustomDataType}
        />
      </Col>
      <Col span={24} style={{ marginTop: 12 }}>
        <DisplayText title="Column Name" style={labelStyle} />
        <OnTraccrTextInput
          onChange={onTextChange}
          value={value}
          placeholder={placeholder}
        />
      </Col>
    </SimpleFormModal>
  );
}

CustomColumnModal.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  validator: PropTypes.func,
  placeholder: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

CustomColumnModal.defaultProps = {
  visible: false,
  validator: null,
  placeholder: '',
};

export default CustomColumnModal;
